import React from 'react';
import { primaryM } from 'web-ui-kit/colors';

function MinusIcon(_ref) {
  var _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? primaryM : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 14 : _ref$width;
  return (
    /*#__PURE__*/
    React.createElement("div", {
      className: className,
      onClick: onClick
    },
    /*#__PURE__*/
    React.createElement("svg", {
      "aria-label": "minus-icon",
      fill: "none",
      height: "2",
      role: "img",
      viewBox: "0 0 14 2",
      width: width,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M14 2H8H7.5H6H0V0H6H7.5H8H14V2Z",
      fill: color
    })))
  );
}

export default MinusIcon;